/**
 * Shared colour + Spanish label maps for Mistral OCR 4 structural block types, used by both
 * {@link BlocksOverlay} and {@link BlockLegend}. Kept in a non-component module so the overlay's
 * `.tsx` only exports its component (react-refresh constraint) and the two views never drift.
 */

/** Stable colour per block type so the same kind reads the same across pages/documents. */
export const BLOCK_COLORS: Record<string, string> = {
  title: '#ef4444',
  header: '#3b82f6',
  footer: '#8b5cf6',
  table: '#10b981',
  signature: '#f59e0b',
  list: '#06b6d4',
  caption: '#ec4899',
  equation: '#14b8a6',
  code: '#64748b',
  references: '#a855f7',
  image: '#6366f1',
  figure: '#6366f1',
  text: '#94a3b8',
};

const UNKNOWN_COLOR = '#6b7280';

/** Spanish display labels per block type; unknown types fall back to the raw type string. */
export const BLOCK_TYPE_LABELS: Record<string, string> = {
  title: 'Título',
  header: 'Encabezado',
  footer: 'Pie',
  table: 'Tabla',
  signature: 'Firma',
  list: 'Lista',
  caption: 'Leyenda',
  equation: 'Fórmula',
  code: 'Código',
  references: 'Referencias',
  image: 'Imagen',
  figure: 'Imagen',
  text: 'Texto',
};

/** Colour for a block type (case-insensitive); a neutral grey for types we don't have a colour for. */
export function blockColor(blockType: string): string {
  return BLOCK_COLORS[blockType.toLowerCase()] ?? UNKNOWN_COLOR;
}

/** Spanish label for a block type (case-insensitive); the raw type string for unknown types. */
export function blockLabel(blockType: string): string {
  return BLOCK_TYPE_LABELS[blockType.toLowerCase()] ?? blockType;
}
